import { connect } from "react-redux";
import CompetitionMappingList from "./CompetitionMappingList";
import { bindActionCreators } from "redux";
import { getCompetitionMappingData } from "services/redux/installation/tagDelivery/action";
const mapStateToProps = (state) => ({
    competititonMappingResponse: state.tagDeliveryReducer.competititonMappingResponse
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getCompetitionMappingData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CompetitionMappingList);
